'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WixStoreApi = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _photographyClientLib = require('@wix/photography-client-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WixStoreApi = exports.WixStoreApi = function () {
  function WixStoreApi(instanceId, instance, locale, wixApi, protocol) {
    (0, _classCallCheck3.default)(this, WixStoreApi);

    this.connectedProvidersCache = null;
    this.galleryDataPromise = null;
    this.instanceId = instanceId;
    this.instance = instance;
    this.locale = locale;
    this.wixApi = wixApi;
    this.protocol = protocol;
  }

  (0, _createClass3.default)(WixStoreApi, [{
    key: 'getStoreGalleryData',
    value: function getStoreGalleryData() {
      var _this = this;

      var ignoreCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.connectedProvidersCache && this.galleryDataPromise) {
        return this.galleryDataPromise;
      } else if (this.connectedProvidersCache && !ignoreCache) {
        this.galleryDataPromise = _promise2.default.resolve(this.connectedProvidersCache);
      } else {
        this.galleryDataPromise = this.sendRequest('GET', 'gallery/' + this.instanceId + '/providers', null).then(function (response) {
          _this.connectedProvidersCache = response;
          return _this.connectedProvidersCache;
        });
      }

      return this.galleryDataPromise;
    }
  }, {
    key: 'getStorePurchasesHistory',
    value: function getStorePurchasesHistory() {
      return _axios2.default.get(this.getUrlPrefix() + '/api/v1/purchase', {
        params: {
          instance: this.instance,
          locale: this.locale,
          deviceType: 'desktop',
          cachekiller: new Date().getTime(),
          isStore: true
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
  }, {
    key: 'connectProvider',
    value: function connectProvider(providerId) {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        _this2.sendRequest('POST', 'providers/' + providerId + '/connect', null).then(function (result) {
          _this2.getProviders().then(function (providersData) {
            if (providersData && Array.isArray(providersData.providers)) {
              var providersList = providersData.providers;
              var connectedProvider = providersList.find(function (providerData) {
                return providerData.providerId === providerId;
              });
              if (connectedProvider) {
                resolve({ result: result, providers: providersData });
              } else {
                reject();
              }
            } else {
              reject();
            }
          });
        });
      });
    }
  }, {
    key: 'getProviders',
    value: function getProviders() {
      return this.sendRequest('GET', 'providers/approved', null).then(function (response) {
        _photographyClientLib.window.providers = response.providers;
        return response;
      });
    }
  }, {
    key: 'sendRequest',
    value: function sendRequest(type, endpoint, data) {
      var url = new _urijs2.default(this.protocol + '//progallery.wixapps.net/editor/api/v1/' + endpoint).search({
        instance: this.instance,
        locale: this.locale,
        deviceType: 'desktop',
        cachekiller: new Date().getTime(),
        isStore: true
      });

      return (0, _axios2.default)({
        method: type,
        url: url.toString(),
        data: data,
        withCredentials: true,
        xsrfCookieName: null,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    }
  }, {
    key: 'getUrlPrefix',
    value: function getUrlPrefix() {
      return this.protocol + '//progallery.wixapps.net/';
    }
  }, {
    key: 'generateUrl',
    value: function generateUrl(endpointFile, params) {
      params = params || {};
      var uri = new _urijs2.default(this.getUrlPrefix() + endpointFile);

      uri.search(params);
      return uri.toString();
    }
  }, {
    key: 'generateBizMgrArtStoreUrl',
    value: function generateBizMgrArtStoreUrl(metasiteId, siteUrl) {
      var EDITOR_X_MANAGE_BASE_URL = 'https://manage.editorx.com';
      var EDITOR_MANAGE_BASE_URL = 'https://www.wix.com';
      var baseUrl = siteUrl.includes('editorx') ? EDITOR_X_MANAGE_BASE_URL : EDITOR_MANAGE_BASE_URL;
      // eslint-disable-next-line new-cap
      var bizMgrUrl = (0, _urijs2.default)(baseUrl).segment('dashboard').segment(metasiteId).segment('art-store').search({ isEditor: true });

      return bizMgrUrl.toString();
    }
  }, {
    key: 'getDashboardUrl',
    value: function getDashboardUrl(options) {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        var doReject = function doReject(message) {
          console.error(message);
          reject(message);
        };
        _this3.wixApi.Settings.getSiteInfo(function (siteInfo) {
          var siteUrl = siteInfo.url;
          _this3.wixApi.Settings.getDashboardAppUrl(function (url) {
            if (url) {
              var uriDashboardUrl = (0, _urijs2.default)(url);
              var arrSegments = uriDashboardUrl.segment();
              var isValidSegment = Array.isArray(arrSegments) && arrSegments.length;
              if (isValidSegment) {
                var metasiteId = null;
                var isMyAccountIndex = arrSegments.indexOf('my-account');
                var isBizMgrIndex = arrSegments.indexOf('dashboard');
                if (isMyAccountIndex !== -1) {
                  metasiteId = arrSegments[isMyAccountIndex + 2]; // format www.wix.com/my-account/sites/[metasite id]/app/[appDefId]
                } else if (isBizMgrIndex !== -1) {
                  metasiteId = arrSegments[isBizMgrIndex + 1]; // format www.wix.com/dashboard/[metasite id]
                } else {
                  doReject('getDashboardUrl - Invalid dashboard url (unknown): ' + url);
                }

                if (metasiteId) {
                  var bizMgrUrl = _this3.generateBizMgrArtStoreUrl(metasiteId, siteUrl);
                  resolve({ url: bizMgrUrl.toString(), title: undefined });
                }
              } else {
                doReject('getDashboardUrl - Invalid dashboard url (format): ' + url);
              }
            } else {
              doReject('getDashboardUrl - No url');
            }
          });
        });
      });
    }
  }, {
    key: 'openDashboard',
    value: function openDashboard() {
      var _this4 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new _promise2.default(function (resolve, reject) {
        _this4.getDashboardUrl(options).then(function (_ref2) {
          var url = _ref2.url,
              title = _ref2.title;

          _this4.wixApi.Settings.openModal(url, '100%', '100%', title, resolve, !title, {
            overlay: 'rgba(0,0,0,0)',
            background: 'rgba(0,0,0,0)',
            margin: '0px 0px 0px 0px',
            padding: false
          });
        }).catch(function (message) {
          reject(message);
        });
      });
    }
  }, {
    key: 'getProviderModalUrl',
    value: function getProviderModalUrl() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.generateUrl('provider-modal.html', (0, _assign2.default)({}, params, { isStore: true }));
    }
  }, {
    key: 'openProviderModal',
    value: function openProviderModal(name, connectedProviders) {
      var _this5 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var containerParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return new _promise2.default(function (resolve, reject) {
        if (name) {
          var providerId = (0, _keys2.default)(connectedProviders)[0];
          var providerData = connectedProviders[providerId];
          var widgets = providerData.widgets;


          if (widgets[name]) {
            var objAdditionalParams = _this5.getProviderUrlOptions(options);
            var finalParams = (0, _assign2.default)({ name: name }, objAdditionalParams, containerParams);
            var providerModalUrl = _this5.getProviderModalUrl(finalParams);
            _this5.wixApi.openPopup(providerModalUrl, '100%', '100%', {
              origin: _this5.wixApi.WindowOrigin.FIXED,
              placement: _this5.wixApi.WindowPlacement.CENTER
            }, function () {
              console.log('Provider modal closed', providerId);
            }, _this5.wixApi.Theme.BARE);
            resolve();
          } else {
            reject('Name \'' + name + '\' does not exist in widgets', providerId);
          }
        } else {
          reject('Name not defined');
        }
      });
    }
  }, {
    key: 'getProviderUrlOptions',
    value: function getProviderUrlOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var urlParams = options.urlParams,
          urlPath = options.urlPath;

      var objAdditionalParams = { urlParams: '{}', urlPath: '/' };
      if (urlParams && (typeof urlParams === 'undefined' ? 'undefined' : (0, _typeof3.default)(urlParams)) === 'object') {
        var encodedParams = (0, _stringify2.default)(urlParams);
        objAdditionalParams.urlParams = encodedParams;
      }
      if (urlPath && typeof urlPath === 'string') {
        objAdditionalParams.urlPath = urlPath;
      }

      return objAdditionalParams;
    }
  }]);
  return WixStoreApi;
}();

var storeApi = null;
if (typeof _photographyClientLib.window !== 'undefined') {
  storeApi = new WixStoreApi(_photographyClientLib.window.instanceId, _photographyClientLib.window.instance, _photographyClientLib.window.locale, _photographyClientLib.Wix, _photographyClientLib.window.location.protocol);
  _photographyClientLib.window.WixStoreApi = storeApi;
}

exports.default = storeApi;